
import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import axios from "axios";
import config from "../../../../config";

const FaqcontentPost = () => {
  const history = useHistory();
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const breadcrumbData = [
    { title: "seobook", href: "/seobook" },
    { title: "url content", href: "#" },
  ];

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    axios
      .get(config.service + "/faqs/", tokenKey)
      .then((res) => setTableData(res.data.faqs))
      .catch((err) => {
        if (err.response.status === 401) window.location.href = "/";
        else toast.error("Error fetching CMS pages", toastAttr);
      });
  }, []);
console.log("tableData",tableData);
  // Helper: short preview of Editor.js content
  const getShortContent = (content) => {
    if (!content || !content.blocks) return "";
    const textBlocks = content.blocks
      .filter((b) => b.type === "paragraph" || b.type === "header")
      .map((b) => b.data.text);
    return textBlocks.join(" ").substring(0, 100) + (textBlocks.join(" ").length > 100 ? "..." : "");
  };

  const deleteRow = (row) => {
    if (!window.confirm("Are you sure you want to delete this page?")) return;
    axios
      .delete(`${config.service}/cmspages/${row.id}/`, tokenKey)
      .then(() => {
        toast.success("Deleted successfully", toastAttr);
        setTableData(tableData.filter((item) => item.id !== row.id));
      })
      .catch(() => toast.error("Error deleting page", toastAttr));
  };

  const renderForm = (row) => {
    history.push({
      pathname: "/seobook/faqcontentform",
      // state: row ? { ...row, editMode: true } : {},
      state:row && { page_type: row.page_type, faqs: row.faqs, editMode: true,mandap:row.mandap,mandap_name:row.mandap_name  },
    });
  };

  const columns = [
  {
    dataField: "page_type",
    text: "Page Type",
    headerStyle: { width: "150px" },
    formatter: (cell, row) => (
      <div style={{ maxWidth: "150px", lineHeight: "18px" }}>
        {row.page_type || ""}
      </div>
    ),
  },
  {
    dataField: "question",
    text: "Question",
    headerStyle: { width: "300px" },
    formatter: (cell, row) => (
      <div style={{ maxWidth: "300px", lineHeight: "18px" }}>
        {row.question || ""}
      </div>
    ),
  },
  {
    dataField: "answer",
    text: "Answer",
    headerStyle: { width: "400px" },
    formatter: (cell, row) => (
      <div style={{ maxWidth: "400px", lineHeight: "18px" }}>
        {row.answer || ""}
      </div>
    ),
  },
  {
    dataField: "is_active",
    text: "Active",
    headerStyle: { width: "100px" },
    formatter: (cell) => (cell ? "Yes" : "No"),
  },
  {
    dataField: "mandap_name",
    text: "Mandap",
    headerStyle: { width: "80px" },
     formatter: (cell, row) => (
      <div style={{ maxWidth: "400px", lineHeight: "18px" }}>
        {row.mandap_name || ""}
      </div>
    ),
  },
  {
    dataField: "id",
    text: "Actions",
    headerStyle: { width: "150px" },
    formatter: (cell, row) => (
      <div style={{ display: "flex", gap: "10px" }}>
        <FiEdit2
          title="Edit"
          style={{ cursor: "pointer" }}
          onClick={() => renderForm(row)}
        />
      </div>
    ),
    events: {
      onClick: (e) => e.stopPropagation(),
    },
  },
];

  const rowEvents = {
    onClick: (e, row) => renderForm(row),
  };

  const options = paginationFactory({
    sizePerPage: 20,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: tableData.length,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <Row className="formBtnsDiv mar-b-10">
                <Col md={8}>
                  <Button variant="primary" onClick={() => renderForm()}>
                    Create
                  </Button>
                </Col>
                <Col md={4}></Col>
              </Row>
              <Row className="vendorList">
                {tableData && (
                  <BootstrapTable
                    bootstrap4
                    wrapperClasses="table-responsive pad-20"
                    data={tableData}
                    columns={columns}
                    keyField="id"
                    rowEvents={rowEvents}
                    hover
                    noDataIndication="No data found"
                    pagination={options}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default FaqcontentPost;